const box = {
    YES: "yes",
    NO: "no",
    not: b => {
        if(b === this.YES) {
            return this.NO;
        } else if(b === this.NO) {
            return this.YES;
        } else {
            throw new Error("invalid box: " + JSON.stringify(b));
        }
    }
}

export default box;


// WEBPACK FOOTER //
// ./src/modules/Box.js